import { Tag } from "antd";
const DEFAULT_COLOR = "blue";

export const ProjectTypeTag = ({ type }: { type: string }) => {
  const getDisplayProps = (type: string) => {
    // TODO: normalize colors for types at some point
    // otherwise (including "new_video") return blue
    if (type === "flash")
      return {
        color: "gold",
        label: "Autopilot",
      };

    if (type === "new_video")
      return {
        color: DEFAULT_COLOR,
        label: "Custom",
      };
    return {
      color: DEFAULT_COLOR,
      label: type
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
    };
  };
  const { color, label } = getDisplayProps(type);

  return (
    <Tag
      color={color}
      style={{
        width: "fit-content",
        maxWidth: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        display: "block",
      }}
    >
      {label}
    </Tag>
  );
};
